/* eslint-disable no-template-curly-in-string */
import R from 'ramda'
import { convertSendDarkTweetFormActionToWidgetAction } from '../form-to-widget/send-dark-tweet'

const SPEED_THREAD_STOP_WIDGET_TYPE = 'SPEED_THREAD_STOP'
const SPEED_THREAD_STOP_FORM_TYPE = 'Stop Speed Thread'

// Context key that action-processor's speedThreadStop emits. The win/lose
// replies branch on the fan's finish time against the configured target.
const TIME_ELAPSED_CONTEXT_KEY = 'timeElapsedInMs'

const isSpeedThreadStopFormType = R.propEq('type', SPEED_THREAD_STOP_FORM_TYPE)

const hasTargetTime = formAction => {
  const target = Number(formAction.targetSeconds)
  return Number.isFinite(target) && target > 0
}

// A lose reply is configured when the operator has given it content (a message
// or a random response). Without it, a target still counts goals but sends a
// single reply to everyone rather than a win/lose split.
const buildBase = () => ({
  type: SPEED_THREAD_STOP_WIDGET_TYPE,
  userId: '${senderId}',
  optinId: '${eventId}',
  timestamp: '${createdTimestamp}',
  userHandle: '${senderHandle}',
  failure: []
})

const convertSpeedThreadStopToWidget = formAction => {
  // No target time: a single reply for everyone, no condition. This is the
  // original behaviour, so speed threads without a win/lose split are untouched.
  if (!hasTargetTime(formAction)) {
    return {
      ...buildBase(),
      success: [convertSendDarkTweetFormActionToWidgetAction(formAction)]
    }
  }

  const targetSeconds = Number(formAction.targetSeconds)

  // The win/lose split is gated solely on the operator ticking the lose-reply
  // checkbox. The lose message is required in the UI (validateTweet), so a
  // ticked-but-blank lose reply can't be saved; we never silently fall back to
  // sending the win reply to everyone. Unticked: record the target (so the
  // scoreboard counts goals under it) and keep a single reply for everyone.
  if (!formAction.enableLoseReply) {
    return {
      ...buildBase(),
      targetSeconds,
      success: [convertSendDarkTweetFormActionToWidgetAction(formAction)]
    }
  }

  // Target + lose reply: the fan's finish time branches the reply. The win reply
  // fires when the time is under the target, the lose reply at or over it.
  const targetMs = targetSeconds * 1000

  const winReply = {
    ...convertSendDarkTweetFormActionToWidgetAction(formAction),
    condition: {
      key: TIME_ELAPSED_CONTEXT_KEY,
      operator: 'lt',
      value: targetMs
    }
  }
  const loseReply = {
    ...convertSendDarkTweetFormActionToWidgetAction(formAction.loseReply),
    condition: {
      key: TIME_ELAPSED_CONTEXT_KEY,
      operator: 'gte',
      value: targetMs
    }
  }

  return {
    ...buildBase(),
    targetSeconds,
    success: [winReply, loseReply]
  }
}

export { isSpeedThreadStopFormType, convertSpeedThreadStopToWidget }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/twitter/form-to-widget/stop-speed-thread.js